import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import { localizeDate as _localizeDate } from '../../../../utils/vuex';
var initialState = {
  activationPrompt: false,
  integrationToActivate: null,
  integrations: [{
    type: 'influxdb',
    isEnabled: false
  }, {
    type: 'grafana',
    isEnabled: false
  }, {
    type: 'states_influxdb',
    isEnabled: false
  }, {
    type: 'iec104',
    isEnabled: false
  }, {
    type: 'iec104_push',
    isEnabled: false
  }]
};
export default {
  name: 'CoreTenantDetailsIntegrations',
  props: {
    accountId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return cloneDeep(initialState);
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])),
  watch: {
    accountId: function accountId() {
      this.resetData();
      return this.fetchIntegrations();
    }
  },
  mounted: function mounted() {
    this.resetData();
    return this.fetchIntegrations();
  },
  methods: {
    get: get,
    set: set,
    resetData: function resetData() {
      Object.assign(this.$data, cloneDeep(initialState));
    },
    fetchIntegrations: function fetchIntegrations() {
      var _this = this;

      if (this.accountId) {
        ApiService.getVersionDriftAccountIntegrations(this.accountId).then(function (res) {
          var integrationMap = (res || []).filter(function (val) {
            return initialState.integrations.findIndex(function (i) {
              return i.type === val.type;
            }) >= 0;
          }).reduce(function (acc, val) {
            val.isEnabled = true;
            acc[val.type] = val;
            return acc;
          }, {});
          _this.integrations = _this.integrations.map(function (integration) {
            return integrationMap[integration.type] || {
              type: integration.type,
              isEnabled: false
            };
          });
        }).catch(function (err) {
          return console.error(err);
        });
      }
    },
    confirmActivation: function confirmActivation(integration) {
      this.integrationToActivate = integration;
      this.activationPrompt = true;
    },
    cancelActivation: function cancelActivation() {
      this.integrationToActivate.isEnabled = false;
      this.integrationToActivate = null;
      this.activationPrompt = false;
    },
    activate: function activate(integration) {
      var _this2 = this;

      this.integrationToActivate = null;
      this.activationPrompt = false;
      ApiService.enableVersionDriftAccountIntegration(this.accountId, integration.type).then(function () {
        _this2.$snack(_this2.$i18n_t('accMgmt.tenant.integrations.activationSuccess'), 'success');

        return _this2.fetchIntegrations();
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('Common.oops1'), 'error');
        }

        integration.isEnabled = false;
      });
    },
    localizeDate: function localizeDate(item) {
      return _localizeDate(item);
    }
  }
};